<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="navBar">
      <img class="homeImg" src="../../assets/img/talk/icon_4_18.png" alt />
      <div @click="goTalk">校园论坛</div>
      <img class="arrow" src="../../assets/img/talk/icon_4_27.png" alt />
      <div v-if="name">{{ name }}</div>
    </div>
    <!-- 无 -->
    <div class="none" v-if="tieList.length == 0">
      <div>您暂时还没有发布过帖子哦</div>
      <div class="none_btn">去发布</div>
    </div>
    <!-- 帖子列表 -->
    <div class="tie_list" v-if="flag">
      <div
        class="tie_big_item"
        v-for="(item1, index1) in tieList"
        :key="index1"
      >
        <div class="tie_top_item">
          <div class="top_name">
            <div>{{ item1.username }}（昵称） 回复：</div>
            <div @click="del(item1.id)">
              <img src="../../assets/img/personal/icon_5_6.png" alt />
              删除
            </div>
          </div>
          <div class="top_from">
            <div>“ {{ item1.content }}”</div>
            <div>
              来自 —
              <span>{{ item1.from }}</span>
            </div>
          </div>
        </div>
        <div class="tie_item">
          <div class="tie_left">
            <img src="../../assets/img/home/img8.png" alt />
            <div>{{ item1.forum.username }}</div>
          </div>
          <div class="tie_tight">
            <div class="tie_title">
              <div>{{ item1.forum.title }}（标题）</div>
            </div>
            <div class="tie_desc">{{ item1.forum.content }}（正文）</div>
          </div>
          <div class="tie_arrow" @click="goTo(item1.forum.id)">
            <img src="../../assets/img/talk/icon_4_26.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myMessage, delForum } from "../../assets/js/api.js";
import Bus from "../../bus.js";
export default {
  props: ["name"],
  data() {
    return {
      tieList: [],
      flag: false,
    };
  },
  mounted() {
    this.getData();
    console.log(this.name);
  },
  methods: {
    del(id) {
      console.log(id);
      return;
      delForum(id).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          let i = this.tieList.findIndex((item) => item.id);
          this.tieList.splice(i, 1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getData() {
      myMessage().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.tieList = res.data.list;
          this.flag = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    goTo(id) {
      // console.log(id);
      this.$emit("child-event", 3);
      Bus.$emit("id", id);
    },
    goTalk() {
      this.$emit("child-event", -1);
    },
  },
};
</script>

<style lang="less" scoped>
.navBar {
  width: 805px;
  // height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .homeImg {
    width: 16px;
    height: 15px;
    margin-right: 10px;
  }

  .arrow {
    width: 7px;
    height: 10px;
    margin: 0 10px;
  }

  div:nth-child(2) {
    color: #999999;
    cursor: pointer;
  }

  div:nth-child(4) {
    color: #029aff;
  }
}

.none {
  font-size: 18px;
  color: #0199ff;
  margin: 200px auto;
  text-align: center;
  .none_btn {
    width: 120px;
    height: 40px;
    background: #0199ff;
    border-radius: 10px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    margin-top: 40px;
    cursor: pointer;
  }
}

.tie_list {
  margin-bottom: 40px;

  .tie_big_item {
    border: 1px solid #e9e9e9;
    margin-bottom: 10px;

    .tie_top_item {
      padding: 17px 25px;
      padding-right: 0;
      box-sizing: border-box;
      background-color: #fff;

      .top_name {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        color: #333333;

        div:nth-child(2) {
          font-size: 14px;
          color: #999;
          cursor: pointer;
          margin-right: 25px;

          img {
            width: 15px;
            height: 17px;
            vertical-align: top;
          }
        }
      }

      .top_from {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        color: #333333;
        margin-top: 20px;
        padding-right: 25px;
        box-sizing: border-box;

        span {
          color: #0199ff;
          cursor: pointer;
        }
      }
    }
  }

  .tie_item {
    padding: 17px 25px;
    padding-right: 0;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    // margin-bottom: 10px;
    border-top: 1px solid #e9e9e9;

    .tie_left {
      color: #333;
      font-size: 14px;
      text-align: center;
      margin-right: 20px;

      img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
      }
    }

    .tie_tight {
      width: 580px;
      border-right: 1px solid #e9e9e9;

      .tie_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        div:nth-child(1) {
          font-size: 18px;
          color: #333;
        }
      }

      .tie_desc {
        width: 560px;
        font-size: 14px;
        color: #656565;
        line-height: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .tie_arrow {
      width: 124px;
      text-align: center;

      img {
        width: 17px;
        height: 27px;
        cursor: pointer;
      }
    }
  }
}
</style>
